import {
  ZodiacAquarius,
  ZodiacAries,
  ZodiacCancer,
  ZodiacCapricorn,
  ZodiacGemini,
  ZodiacLeo,
  ZodiacLibra,
  ZodiacPisces,
  ZodiacSagittarius,
  ZodiacScorpio,
  ZodiacTaurus,
  ZodiacVirgo,
  type LucideIcon,
} from 'lucide-react';

import type { AccountUserProfileHoroscope } from '../services/accountUserProfileService';

export const HOROSCOPE_LUCIDE_ICONS: Record<AccountUserProfileHoroscope, LucideIcon> = {
  aries: ZodiacAries,
  taurus: ZodiacTaurus,
  gemini: ZodiacGemini,
  cancer: ZodiacCancer,
  leo: ZodiacLeo,
  virgo: ZodiacVirgo,
  libra: ZodiacLibra,
  scorpio: ZodiacScorpio,
  sagittarius: ZodiacSagittarius,
  capricorn: ZodiacCapricorn,
  aquarius: ZodiacAquarius,
  pisces: ZodiacPisces,
};
